const zh_CN = {
  builder_btn: '新手模式',
};
export default zh_CN;
